<template>
  <div class="accordion">
    <div
      class="accordion_head"
      @click="isOpen = !isOpen"
      :class="{ '-open': isOpen }"
    >
      {{ data.head }}
    </div>
    <div class="accordion_body" v-if="isOpen">
      <p>
        {{ data.body }}
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'CbtAccordion',

  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },

  setup() {
    const isOpen = ref(false)

    return {
      isOpen
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.accordion {
  &_head {
    background: url('~@/assets/images/icon/accordion-plus.svg') no-repeat;
    background-position: top 2px right;
    color: var.$color-main-text;
    padding-bottom: 16px;
    font-size: 1.6rem;
    line-height: 1.43;
    font-weight: bold;
    border-bottom: 1px solid var.$color-border-gray;
    cursor: pointer;
    &.-open {
      background-image: url('~@/assets/images/icon/accordion-minus.svg');
    }
  }
  &_body {
    margin-top: 16px;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
}
</style>
